// L'écusson du club adverse (annuaire des clubs, D-094) : son logo FFBB s'il est connu, sinon le
// monogramme de la fiche de match (la lettre du mot le plus long : « ASC Valdorne » → A). L'écran
// s'affiche tout de suite avec le monogramme ; les logos arrivent ensuite (fillCrests), en une requête.
// Le logo d'un club ne s'affiche que pour ses propres matchs : il vient de l'organisme FFBB du match.
import { orgCards } from '../lib/annuaire';
import { opponentInitial } from '../domain/match-phase';
import { $$, html, type Html } from './dom';

export interface CrestMatch { opponent: string; opponent_org?: string | null }

/** Le rond de l'adversaire (`cls` : taille ou habillage du lieu). `logo` : déjà connu (fiche de match). */
export const oppCrest = (m: CrestMatch, cls = '', logo?: string | null): Html => logo
  ? html`<span class="opp-crest has-logo ${cls}" aria-hidden="true"><img src="${logo}" alt=""></span>`
  : html`<span class="opp-crest ${cls}" data-org="${m.opponent_org ?? ''}" aria-hidden="true">${opponentInitial(m.opponent)}</span>`;

/** Remplace les monogrammes par les logos connus de l'annuaire (ceux que le compte peut voir). */
export async function fillCrests(root: ParentNode): Promise<void> {
  const els = $$<HTMLElement>(root, '.opp-crest[data-org]').filter(e => e.dataset.org);
  if (!els.length) return;
  const cards = await orgCards(els.map(e => e.dataset.org)).catch(() => null);
  for (const el of els) {
    const logo = cards?.get(el.dataset.org!)?.logo;
    if (!logo || !el.isConnected) continue;
    const img = document.createElement('img');
    img.src = logo; img.alt = '';
    el.replaceChildren(img);
    el.classList.add('has-logo');
  }
}

/** Le logo d'un adversaire, s'il est connu (en-tête de la fiche de match, carte du résultat). */
export async function crestLogo(m: CrestMatch): Promise<string | null> {
  if (!m.opponent_org) return null;
  return (await orgCards([m.opponent_org]).catch(() => null))?.get(m.opponent_org)?.logo ?? null;
}
